import React from "react";
import "./SocialMedia.css";
import { socialMediaLinks } from "../../portfolio";

// Enhanced FontAwesome class mapping with proper icons
const getCorrectIconClass = (iconName) => {
  const iconClassMap = {
    "fa-linkedin-in": "fab fa-linkedin-in",
    "fa-github": "fab fa-github",
    "fa-medium": "fab fa-medium-m",
    "fa-google": "fas fa-envelope",
    "fa-twitter": "fab fa-twitter",
    "fa-instagram": "fab fa-instagram",
    "fa-solid fa-baseball-bat-ball": "fas fa-baseball-bat-ball",
    "fa-trophy": "fas fa-trophy",
    "fa-baseball": "fas fa-baseball",
    "fa-futbol": "fas fa-futbol",
    "fa-robot": "fas fa-robot",
  };
  return iconClassMap[iconName] || "fas fa-link";
};

export default function socialMedia(props) {
  return (
    <div className="social-media-div">
      {socialMediaLinks.map((media, index) => {
        return (
          <a
            key={index}
            href={media.link}
            className="icon-button"
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: media.backgroundColor }}
            title={media.name}
          >
            <i className={getCorrectIconClass(media.fontAwesomeIcon)}></i>
          </a>
        );
      })}

      {/* Resume Icon */}
      <a
        href="https://drive.google.com/file/d/1gDpj8yluGhBAWeJ-5BjT8OUbtHJ8abB2/view?usp=share_link"
        className="icon-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{ backgroundColor: "#667eea" }}
        title="Resume"
      >
        <i className="fas fa-file-pdf"></i>
      </a>
    </div>
  );
}
